import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Waves from '@loggi/ui/components/waves';
import View from '@loggi/ui/components/view';
import * as shapes from './shapes';
import getTransformFromBearing from '../utils/get-transform-from-bearing';
import styles from './styles/marker.scss';

const WAVES_SIZE = 80;
const WAVES_COLOR = 'brand-default';
const TYPE_MOTO = 'moto';
const TYPE_VAN = 'van';
const DEFAULT_TYPE = TYPE_MOTO;

function DriverMarker(props) {
  const DriverShape = shapes[props.type];
  const bearing = getTransformFromBearing(props.bearing || 0);
  const wave = props.waves ? (
    <Waves
      className={styles.wavesMarker}
      color={WAVES_COLOR}
      size={WAVES_SIZE}
    />
  ) : null;
  const wrapDriverClasses = classNames([styles.wrapPin, props.className]);

  return (
    <View className={wrapDriverClasses} style={bearing}>
      {wave}
      <DriverShape className={styles.driverPin} />
    </View>
  );
}

DriverMarker.displayName = 'DriverMarker';

DriverMarker.propTypes = {
  className: PropTypes.string,
  bearing: PropTypes.number,
  waves: PropTypes.bool,
  type: PropTypes.oneOf([TYPE_MOTO, TYPE_VAN])
};

DriverMarker.defaultProps = {
  waves: true,
  type: DEFAULT_TYPE,
  bearing: 0
};

DriverMarker.VAN = TYPE_VAN;
DriverMarker.MOTO = TYPE_MOTO;

export default DriverMarker;
